import type { AuthUser } from '../types/auth';
import type { Item } from '../types/item';

export const parseInventoryQty = (value: string | null | undefined): number => {
  const n = parseFloat(value ?? '0');
  return Number.isFinite(n) ? n : 0;
};

export const hasOpenBackorders = (item: Pick<Item, 'backorder_qty'>): boolean =>
  parseInventoryQty(item.backorder_qty) > 0;

export const isOversoldItem = (item: Pick<Item, 'qty_on_hand' | 'backorder_qty'>): boolean =>
  parseInventoryQty(item.qty_on_hand) < 0 && hasOpenBackorders(item);

export const isAdminRole = (): boolean =>
  localStorage.getItem('user_role')?.toUpperCase() === 'ADMIN';

export const getStoredAuthUser = (): AuthUser | null => {
  const raw = localStorage.getItem('user');
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AuthUser;
  } catch {
    return null;
  }
};

export const getAllowNegativeInventory = (): boolean =>
  Boolean(getStoredAuthUser()?.company?.allow_negative_inventory);

export const qtyOnHandClassName = (qty: string): string => {
  if (parseInventoryQty(qty) < 0) return 'text-red-600 font-medium';
  return 'text-gray-900';
};

export const lineExceedsOnHand = (qty: number, qtyOnHand: string): boolean =>
  qty > parseInventoryQty(qtyOnHand);
